export const PERMISSIONS_CONFIG = {
  dashboard: [],
  teamMember: ['create_team_member_invitation', 'delete_team_member', 'cancel_team_member_invitation', 'get_team_member_active_count', 'get_team_member_invitations', 'get_team_members', 'update_team_member_activation', 'update_team_member_roles'],
  vouchers: ['my_vouchers_buy', 'my_vouchers_merge', 'my_vouchers_redeem', 'my_vouchers_split', 'my_vouchers_view'],
  balanceHistory: ['my_wallet_transactions_view', 'my_wallets_view', 'my_wallet_transaction_view'],
  transactionDetails: ['my_crypto_transactions_details'],
  requestDetails: ['my_crypto_transactions_details'],
  cryptoTransactions: ['my_crypto_transactions_details', 'my_crypto_transactions_export', 'my_crypto_transactions_view'],
  buyVoucher: ['my_vouchers_buy'],
  redeemVoucher: ['my_vouchers_redeem'],
  mergeVoucher: ['my_vouchers_merge'],
  splitVoucher: ['my_vouchers_split'],
  newSettlement: ['create_settlement'],
  whitelist: ['create_whitelist', 'get_whitelists', 'toggle_whitelist_activation', 'remove_whitelist', 'toggle_enabled_whitelist', 'get_whitelist_status'],
}
